var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionBankActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M21.375 20.588h-.625v-1.764c0-.585-.42-1.06-.938-1.06H18.25V10H17v7.765H7V10H5.75v7.765H4.187c-.517 0-.937.474-.937 1.059v1.764h-.625c-.345 0-.625.316-.625.706v.353c0 .195.14.353.313.353h19.375c.172 0 .312-.158.312-.353v-.353c0-.39-.28-.706-.625-.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M5 19h15v1H5zM21.698 6.55l-9.105-4.442a1.682 1.682 0 00-1.186 0L2.302 6.55A.526.526 0 002 7.04v.385c0 .29.21.525.469.525h.781v.525c0 .29.21.525.469.525H20.28c.26 0 .469-.235.469-.525V7.95h.781c.26 0 .469-.235.469-.525v-.384a.526.526 0 00-.302-.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M20 8H5v-.567l7.342-3.411a.566.566 0 01.316 0L20 7.433V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M11.85 15.1a.85.85 0 00-.717.395l-.013.021a.851.851 0 00.631 1.278l.099.006.099-.006a.851.851 0 00-.099-1.694zm.04-5.1c-1.098 0-1.799.475-2.349 1.319a.253.253 0 00.01.291l.045.045.635.44.056.033c.02.008.04.013.06.016h.061l.06-.016a.241.241 0 00.1-.076c.36-.469.657-.794 1.206-.794.542 0 1.073.307 1.073.794 0 .275-.333.599-.662.794l-.326.19c-.4.238-.713.425-.777 1.051l-.008.163v.083l.009.066c.022.084.087.15.169.174l.064.008.966.019.064-.009a.246.246 0 00.169-.173l.009-.066v-.028l.009-.074c.133-.52 1.707-.617 1.707-2.14 0-1.2-1.213-2.11-2.35-2.11z"
  }))));
}

export default SvgQuestionBankActive;